module.exports = __webpack_public_path__ + "static/img/IMG_20160310_223439.05c6a36e.jpg";